export default __webpack_public_path__ + "static/media/chevereto.b23b6d6f.svg";